// script.js

function initCarousels() {
  var carousels = document.querySelectorAll('.carousel');
  for (var i = 0; i < carousels.length; i++) {
    tns({
      container: carousels[i],
      mouseDrag: true,
      nav: carousels[i].classList.contains('carousel-show-nav'),
      navPosition: 'bottom',
    });
  }

  document.querySelectorAll('.carousel-timeline').forEach(function (el) {
    const slider = tns({
      speed: 600,
      container: el,
      center: true,
      edgePadding: 300,
      center: true,
      loop: false,
      fixedWidth: 300,
      viewportMax: 30,
      swipeAngle: false,
      mouseDrag: true,
      nav: true,
      navPosition: 'bottom',
      navAsThumbnails: true,
    });

    function setActiveTimelineSlide(sliderInfo) {
      const currentSlide = sliderInfo.slideItems[sliderInfo.index];
      const prevSlide = sliderInfo.slideItems[sliderInfo.indexCached];
      if (currentSlide) {
        currentSlide.setAttribute('data-tns-m-active', '');
      }
      if (prevSlide && prevSlide != currentSlide) {
        prevSlide.removeAttribute('data-tns-m-active');
      }
    }

    slider.events.on('indexChanged', setActiveTimelineSlide);
    setActiveTimelineSlide(slider.getInfo());
  });
}

function initCountUps() {
  document.querySelectorAll('[data-count-up]').forEach(
    (el) =>
      new countUp.CountUp(el, null, {
        autoAnimate: true,
        autoAnimateOnce: true,
        useIndianSeparators: true,
      }),
  );
}

function main(event) {
  var isInitialLoad = !event; // fires first time on document.ready, not pjax event

  if (isInitialLoad) {
  }

  initCarousels();
  initCountUps();
}

$(function () {
  main(false);
});
